// extracted by mini-css-extract-plugin
export default {"itpQuotesTable":"styles__itpQuotesTable__f8bc0d64dc4c35db3333","flexRowContentStart":"styles__flexRowContentStart__fe370fc42859a1829779"};